import {EnvironmentType} from '../../../shared/model/EnvironmentType.model';

export type EnvironmentAttributes = {
  readonly type: EnvironmentAttributesType;
};

export type Environment<T extends EnvironmentAttributes> = {
  readonly accessKey: string;
  readonly secretKey: string,
  attributes: T,
  attributesType: string,
  createdOn: string;
  id: number;
  merchantId: number;
  type: EnvironmentType;
};

export enum EnvironmentAttributesType {
  CustomEnvironmentAttributes = 'CustomEnvironmentAttributes',
  ShopifyEnvironmentAttributes = 'ShopifyEnvironmentAttributes',
  WooCommerceEnvironmentAttributes = 'WooCommerceEnvironmentAttributes'
}

export enum StatusPageHandling {
  SWIFTPAY = 'SWIFTPAY',
  EXTERNAL = 'EXTERNAL'
}
